var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "research") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "homepage-first-implementation",
    transform: "translate(-350.000000, -1920.000000)",
    fill: "#1E4E74",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s6-platform",
    transform: "translate(-1.000000, 1409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(120.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(0.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "service1-copy-7",
    transform: "translate(181.006920, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "research",
    transform: "translate(17.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5416992,0 L3.125,0 C1.39912109,0 0,1.39912109 0,3.125 L0,28.125 C0,29.8508789 1.39912109,31.25 3.125,31.25 L16.6666992,31.25 L16.6666992,29.1666992 L3.125,29.1666992 C2.54970703,29.1666992 2.08330078,28.700293 2.08330078,28.125 L2.08330078,3.125 C2.08330078,2.54970703 2.54970703,2.08330078 3.125,2.08330078 L38.5416992,2.08330078 C39.1169922,2.08330078 39.5833984,2.54970703 39.5833984,3.125 L39.5833984,21.875 L41.6666992,21.875 L41.6666992,3.125 C41.6666992,1.39912109 40.2675781,0 38.5416992,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12.5,
    y: 30.2083008,
    width: 2.08330078,
    height: 6.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0698242,22.0645508 C35.947168,19.9415039 33.0679688,18.7489258 30.0658203,18.7489258 C23.8152344,18.7492188 18.7485352,23.8165039 18.7485352,30.0670898 C18.7488281,36.3176758 23.8161133,41.384375 30.0666992,41.384375 C33.0678711,41.384375 35.9459961,40.1921875 38.0683594,38.0702148 C42.4885742,33.6507812 42.4892578,26.4848633 38.0698242,22.0645508 Z M30.0604492,39.3020513 C24.9604492,39.300293 20.8274414,35.1645508 20.8291987,30.0645508 C20.830957,24.9645508 24.9666992,20.831543 30.0666992,20.8332671 C32.5179688,20.8266602 34.8698242,21.8020508 36.596875,23.5416016 C38.3271484,25.2738281 39.2987305,27.6223633 39.2979497,30.0708008 C39.2961914,35.1708008 35.1604492,39.3038086 30.0604492,39.3020513 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6948242,45.3125 L43.15625,38.7760742 C42.9609375,38.5807617 42.6959961,38.4708984 42.4198242,38.4708984 C42.1435547,38.4708984 41.8787109,38.5807617 41.6833984,38.7760742 L38.7771484,41.6823242 C38.3705078,42.0890625 38.3705078,42.7484375 38.7771484,43.1552734 L45.3157227,49.6948242 C45.5110352,49.8902344 45.7759766,50 46.0521484,50 L46.0521484,50 C46.3288086,49.9991211 46.5938477,49.8881836 46.7885742,49.6916992 L49.6948242,46.7854492 C50.1014648,46.3786133 50.1014648,45.7192383 49.6948242,45.3125 Z M46.0520508,47.4854492 L40.9864258,42.41875 L42.4197266,40.9854492 L47.4853516,46.0521484 L46.0520508,47.4854492 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(39.149493, 39.148942) rotate(-45.000000) translate(-39.149493, -39.148942) ",
    points: "38.1078523 36.5802162 40.1911331 36.5802162 40.1911331 41.7176669 38.1078523 41.7176669"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.4166992,
    y: 35.4166992,
    width: 8.33330078,
    height: 2.08330078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625,4.16669922 C13.8991211,4.16669922 12.5,5.56582031 12.5,7.29169922 C12.5,9.01757812 13.8991211,10.4166992 15.625,10.4166992 C17.3508789,10.4166992 18.75,9.01757812 18.75,7.29169922 C18.75,5.56582031 17.3508789,4.16669922 15.625,4.16669922 Z M15.625,8.33330078 C15.049707,8.33330078 14.5833008,7.86689453 14.5833008,7.29160156 C14.5833008,6.71630859 15.049707,6.24990234 15.625,6.24990234 C16.200293,6.24990234 16.6666992,6.71630859 16.6666992,7.29160156 C16.6666992,7.86699219 16.200293,8.33330078 15.625,8.33330078 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9166992,11.4583008 C21.1908203,11.4583008 19.7916992,12.8574219 19.7916992,14.5833008 C19.7916992,16.3091797 21.1908203,17.7083008 22.9166992,17.7083008 C24.6425781,17.7083008 26.0416992,16.3091797 26.0416992,14.5833008 C26.0416992,12.8574219 24.6425781,11.4583008 22.9166992,11.4583008 Z M22.9166992,15.625 C22.3414063,15.625 21.875,15.1585937 21.875,14.5833008 C21.875,14.0080078 22.3414063,13.5416016 22.9166992,13.5416016 C23.4919922,13.5416016 23.9583984,14.0080078 23.9583984,14.5833008 C23.9583008,15.1585937 23.4919922,15.625 22.9166992,15.625 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(11.979056, 10.937784) rotate(-45.000000) translate(-11.979056, -10.937784) ",
    points: "8.29627574 9.8961432 15.6618301 9.8961432 15.6618301 11.979424 8.29627574 11.979424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(19.266263, 10.940457) rotate(-45.000000) translate(-19.266263, -10.940457) ",
    points: "18.2246128 7.25764551 20.3078936 7.25764551 20.3078936 14.6231999 18.2246128 14.6231999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2083008,4.16669922 C28.4824219,4.16669922 27.0833008,5.56582031 27.0833008,7.29169922 C27.0833008,9.01757812 28.4824219,10.4166992 30.2083008,10.4166992 C31.9341797,10.4166992 33.3333008,9.01757812 33.3333008,7.29169922 C33.3333984,5.56582031 31.9342773,4.16669922 30.2083008,4.16669922 Z M30.2083008,8.33330078 C29.6330078,8.33330078 29.1666016,7.86689453 29.1666016,7.29160156 C29.1666016,6.71630859 29.6330078,6.24990234 30.2083008,6.24990234 C30.7835938,6.24990234 31.25,6.71630859 31.25,7.29160156 C31.25,7.86699219 30.7835938,8.33330078 30.2083008,8.33330078 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(26.561877, 10.941410) rotate(-45.000000) translate(-26.561877, -10.941410) ",
    points: "22.8790568 9.89976969 30.2446111 9.89976969 30.2446111 11.9830505 22.8790568 11.9830505"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.b7b6e583.svg";
export { ForwardRef as ReactComponent };